/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { Input2, Button, SearchableDropDown, SearchManufacturer } from "components";
import { useInput } from "hooks";
import { useMutation } from "react-query";
import { createBrandApi, getManufacturersAPI, getMergedBrandApi } from "api";
import { useAuthContext, useMainContext } from "contexts";
import { useCategoryStore } from "store/CategoryStore";
import { toast } from "react-toastify";

export const CreateBrand = ({
  originName,
  onCancel = () => {},
  onOk = () => {},
}) => {
  const name = useInput("");
  const category = useInput("");
  const manufacturer = useInput("");
  const [mergedBrand, setMergedBrand] = useState("");
  const { postPageEvents, currentAdBlockId } = useMainContext();
  const { userInfo } = useAuthContext();
  const createMutation = useMutation((data) => createBrandApi(data));
  const checkMergedMutation = useMutation((name) => getMergedBrandApi(name));

  const handleCheckMerged = async () => {
    try {
      postPageEvents("click", "Check Merged Brand");
      const brandName = name.value.trim();

      const response = await checkMergedMutation.mutateAsync(brandName);

      if (response.success) {
        const mergedBrandName = response.payload?.brand_name;

        if (mergedBrandName) {
          setMergedBrand(mergedBrandName);
          toast.info(`This brand has been merged with ${mergedBrandName}`);
        } else {
          handleCreate();
        }
      } else {
        handleCreate();
      }
    } catch (error) {
      console.error("Error checking merged brand:", error);
    }
  };

  const handleUseMerged = async () => {
    postPageEvents("click", "Use Merged Brand");
    name.value = mergedBrand;
    await handleCreate();
  }


  const handleCreate = async () => {
    postPageEvents("click", "Create Brand");
    const res = await createMutation.mutateAsync({
      brand_name: name.value,
      sub_cat_i: category.value === "" ? null : category.value,
      mfg_id: manufacturer.value === "" ? null : manufacturer.value,
      adblock_uuid: currentAdBlockId
    });
    onOk(res.payload.ext_id, res.payload.brand_name, res.payload);
  };
  const handleCancel = () => {
    postPageEvents("click", "Cancel Create Brand");
    onCancel();
  };

  const categories = useCategoryStore(state => state.categories);
  const fetchCategories = useCategoryStore(state => state.fetchCategories);
  const depth5Categories = useMemo(() => (Array.isArray(categories) ? categories : []).filter(item => item.depth === 5), [categories]);

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    name.setValue(originName);
    return () => {};
  }, [originName]);

  return (
    <Container>
      <Header>CREATE BRAND</Header>
      <Content>
        <Text className="mb-2">
          Please make sure the brand does not already exist
        </Text>
        <Input2 label="New Brand Name" className="mt-2" {...name} />
        {userInfo.user?.is_superuser &&
        <SearchableDropDown
          className="mt-2"
          label="Select Sub Category (optional)"
          placeholder="-- Select a sub category --"
          data={depth5Categories.map((item) => ({
            id: item.level_i,
            title: item.level_nm,
          }))}
          {...category}
        />}
        <SearchManufacturer
          className="mt-2"
          label="Select Manufacturer (optional)"
          placeholder="-- Select a manufacturer --"
          func={getManufacturersAPI}
          onChange={e => manufacturer.setValue(e)}
        />
        <div className="d-flex mt-4">
          <Button
            size="small"
            buttonTheme="dark"
            className="ml-auto"
            width="100px"
            onClick={handleCancel}
          >
            CANCEL
          </Button>
          <Button
            size="small"
            buttonTheme="dark"
            className="ml-2"
            width="150px"
            onClick={handleCheckMerged}
            isLoading={createMutation.isLoading || checkMergedMutation.isLoading}
            disabled={!name.value || mergedBrand}
          >
            CREATE BRAND
          </Button>
        </div>
        {mergedBrand && (<>
          <Text className="mt-2">
            This brand has been merged with <span style={{
              color: "yellow",
              textDecoration: "underline",
              cursor: "pointer"
            }}>{mergedBrand}</span>
          </Text>
          <Text>
            Do you want to use the merged brand or create a new one?
          </Text>
          <div className="d-flex justify-content-center mt-4">
            <Button
              size="small"
              buttonTheme="dark"
              width="150px"
              onClick={handleUseMerged}
              isLoading={createMutation.isLoading || checkMergedMutation.isLoading}
            >
              USE MERGED
            </Button>
            <Button
              size="small"
              className="ml-2"
              buttonTheme="dark"
              width="150px"
              onClick={handleCreate}
              isLoading={createMutation.isLoading || checkMergedMutation.isLoading}
            >
              CREATE NEW
            </Button>
          </div>
        </>
        )}
      </Content>
    </Container>
  );
};
const Text = styled.div`
  font-size: 14px;
`;
const Container = styled.div`
  width: 380px;
  flex: 1;
  margin: 2px 2px;
  background: ${(props) => props.theme.palette.backgrounds};
  padding: 12px 8px;
`;

const Header = styled.div`
  text-transform: uppercase;
  color: white;
  font-size: ${(props) => props.theme.font.size.m};
  border-bottom: 1px solid ${(props) => props.theme.palette.secondary};
  position: relative;

  svg {
    position: absolute;
    top: 0;
    right: 0;
    color: white;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 8px;
  flex: 1;
  max-height: calc(100% - 12px);
  color: white;
`;
